"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Briefcase, Users, Building2, HeartHandshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ATrustedInstitution() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const careers = [{
    title: "Healthcare Assistants",
    description: "Support vulnerable individuals with compassionate personal care and companionship services.",
    icon: HeartHandshake
  }, {
    title: "Reception Administrator",
    description: "Help families and visitors feel welcomed while supporting office administration.",
    icon: Building2
  }, {
    title: "Front Desk Team",
    description: "Organised professionals supporting daily healthcare coordination and communication.",
    icon: Users
  }];
  return <section id="our-story-mission" className="relative overflow-hidden bg-white px-4 py-14 md:px-6 lg:py-16">

      {}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/healthcare_mission_background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/healthcare_mission_background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/healthcare_mission_background.png-wvc-sizes" alt="Compassionate healthcare environment background" className="absolute inset-0 -z-20 h-full w-full object-cover opacity-10" loading="lazy" decoding="async" />

        <div className="absolute -left-24 top-0 h-64 w-64 rounded-lg bg-teal-100 blur-3xl opacity-30" />

        <div className="absolute bottom-0 right-0 h-64 w-64 rounded-lg bg-cyan-100 blur-3xl opacity-20" />

      </div>

      <div ref={ref} className={`mx-auto max-w-6xl transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>

        {}
        <div className="mx-auto max-w-2xl text-center">

          <p className="text-sm font-bold uppercase tracking-[0.2em] text-teal-700">
            About & Careers
          </p>

          <h2 className="mt-3 text-4xl font-bold tracking-tight text-slate-900 md:text-5xl">
            Join The Cynthylee Care Team
          </h2>

          <p className="mt-4 text-lg leading-8 text-slate-600">
            Compassionate care delivered by dedicated healthcare
            professionals serving Brighton & Hove communities.
          </p>

        </div>

        {}
        <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_0.9fr] lg:gap-10">

          {}
          <div className="space-y-5">

            {}
            <div className="rounded-3xl bg-slate-50 p-6 ring-1 ring-slate-100">

              <h3 className="text-2xl font-bold text-slate-900">
                Care With Dignity & Compassion
              </h3>

              <p className="mt-4 leading-7 text-slate-700">
                Cynthylee Health Care is a CQC-registered provider
                supporting families across Brighton & Hove with
                compassionate, person-centred home care services.
              </p>

              <p className="mt-4 leading-7 text-slate-700">
                Our multicultural team of professional caregivers
                is committed to delivering respectful and trusted
                support that helps individuals remain independent
                in the comfort of their own homes.
              </p>

            </div>

            {}
            <div>

              <div className="mb-4 flex items-center gap-3">

                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-teal-100 text-teal-700">
                  <Briefcase className="h-5 w-5" />
                </div>

                <div>
                  <h3 className="text-2xl font-bold text-slate-900">
                    We’re Hiring
                  </h3>

                  <p className="text-slate-600">
                    Build your healthcare career with us.
                  </p>
                </div>

              </div>

              <div className="grid gap-3">

                {careers.map(career => {
                const Icon = career.icon;
                return <div key={career.title} className="rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition hover:shadow-md">

                      <div className="flex gap-4">

                        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-teal-700">
                          <Icon className="h-5 w-5" />
                        </div>

                        <div>

                          <h4 className="text-lg font-semibold text-slate-900">
                            {career.title}
                          </h4>

                          <p className="mt-1 leading-7 text-slate-600">
                            {career.description}
                          </p>

                        </div>

                      </div>

                    </div>;
              })}

              </div>

            </div>

          </div>

          {}
          <Card className="overflow-hidden border border-slate-200 shadow-lg">

            <CardContent className="p-0">

              <div className="relative">

                <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?q=80&w=1200&auto=format&fit=crop" alt="Professional African healthcare caregivers supporting elderly care" className="h-[300px] w-full object-cover md:h-[480px]" />

                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent" />

                {}
                <div className="absolute bottom-4 left-4 rounded-2xl bg-white/95 p-4 shadow-xl backdrop-blur">

                  <p className="text-xs font-bold uppercase tracking-widest text-teal-700">
                    Careers
                  </p>

                  <p className="mt-1 text-sm font-semibold text-slate-900">
                    Reception • Front Desk • Healthcare Assistants
                  </p>

                </div>

              </div>

            </CardContent>

          </Card>

        </div>

      </div>

    </section>;
}